"use client"
// src/layouts/timeline/timeline.tsx
import DateTile from "@a24/ui/DateTile";
import Divider from "@a24/ui/Divider";
import Slider from "@a24/ui/Slider";
import Title from "@a24/ui/Title";
import { format, isToday, isTomorrow } from "date-fns";
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Timeline = ({
  className = "",
  dateTiles,
  id,
  labels = {
    showTimesHeading: "Next show",
    today: "Today",
    tomorrow: "Tomorrow"
  }
}) => {
  if (dateTiles !== void 0 && dateTiles.length <= 0) return null;
  const groupedTilesRef = useRef([]);
  const orderTiles = (dateTiles2) => {
    const daysGroups = [];
    dateTiles2?.forEach((tile) => {
      const dayGroup = daysGroups.find(
        (d) => d.dateIndex === Number.parseInt(format(tile?.startDate || "", "Ldy"))
      );
      if (dayGroup) {
        dayGroup.dateTiles?.push(tile);
      } else {
        daysGroups.push({
          dateIndex: Number.parseInt(format(tile?.startDate || "", "Ldy")),
          dateTiles: [tile]
        });
      }
    });
    return daysGroups;
  };
  const groupedTiles = orderTiles(dateTiles);
  useEffect(() => {
    if (groupedTiles) {
      groupedTilesRef.current = groupedTilesRef.current.slice(
        0,
        groupedTiles.length
      );
    }
  }, [groupedTiles]);
  function computeDayLabel(tile) {
    if (isToday(tile?.startDate || "")) {
      return labels.today;
    }
    if (isTomorrow(tile?.startDate || "")) {
      return labels.tomorrow;
    }
    return format(tile?.startDate || "", "EEEE");
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `full-viewport-width theme-dark pt-[4.5rem] pb-[4.5rem] sm:mt-24 ${className}`,
      id,
      children: /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-12 gap-x-3 max-w-[1440px] mx-auto relative sm:gap-x-6", children: [
        /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 row-start-1 md:col-span-8 md:col-start-1 max-md:px-6 max-2xl:px-16", children: /* @__PURE__ */ jsx(
          Title,
          {
            className: "heading-lg max-w-3/4",
            level: "h2",
            text: labels.showTimesHeading
          }
        ) }),
        /* @__PURE__ */ jsx(
          Slider,
          {
            navigationClassName: "col-span-full content-end row-span-1 row-start-1 text-end md:col-span-3 md:col-start-10 max-md:px-6 max-2xl:px-16",
            sliderClassName: "no-scroll-bar full-viewport-width col-span-full grid gap-x-2 grid-flow-col overflow-x-auto relative snap-x scroll-p-[var(--outter-gutter)] snap-mandatory pb-8",
            slidesRef: groupedTilesRef.current,
            children: groupedTiles?.map((group, i) => {
              const groupTiles = group.dateTiles || [];
              const dayLabel = computeDayLabel(groupTiles[0]);
              const isFirst = i === 0;
              const isLast = i === groupedTiles.length - 1;
              const dividerStyle = isFirst ? "left-[calc(0.5*var(--datetile-width-mobile))] w-[calc(100%-calc(0.5*var(--datetile-width-mobile)))] lg:left-[calc(0.5*var(--datetile-width))] lg:w-[calc(100%-calc(0.5*var(--datetile-width)))]" : isLast ? "-left-2 w-[calc(100%+var(--spacing)*2-calc(0.5*var(--datetile-width-mobile)))] lg:w-[calc(100%+var(--spacing)*2-calc(0.5*var(--datetile-width)))]" : "-left-2 w-[calc(100%+var(--spacing)*2)]";
              const indentFirstItem = isFirst ? "pl-6 lg:pl-16" : "";
              const indentLastItem = isLast ? "pr-6 lg:pr-16" : "";
              return /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: (el) => {
                    groupedTilesRef.current[i] = el;
                  },
                  className: `relative grid auto-cols-[var(--datetile-width-mobile)] lg:auto-cols-[var(--datetile-width)] gap-x-2 grid-flow-col grow-1 shrink-0  pt-21 mt-14 ${indentFirstItem} ${indentLastItem}`,
                  children: [
                    dayLabel && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: `w-[100%] absolute top-0 left-0 flex flex-col ${indentFirstItem} ${indentLastItem}`,
                        children: [
                          /* @__PURE__ */ jsx("div", { className: "self-start heading-sm relative top-0 left-[calc(0.5*var(--datetile-width-mobile))] lg:left-[calc(0.5*var(--datetile-width))] pb-2.5 translate-x-[-50%] z-1 after:absolute after:left-[calc(50%-0.25em)] after:-bottom-[calc(var(--spacing)*1+0.5px)] after:rounded-full chip-primary after:w-2 after:h-2 after:outline-3", children: dayLabel }),
                          /* @__PURE__ */ jsx(Divider, { className: `relative ${dividerStyle}` })
                        ]
                      }
                    ),
                    group.dateTiles?.map((tile) => {
                      return /* @__PURE__ */ jsx(
                        DateTile,
                        {
                          ...tile,
                          className: `${tile.className}`
                        },
                        tile.id
                      );
                    })
                  ]
                },
                group.dateIndex
              );
            })
          }
        )
      ] })
    }
  );
};
var timeline_default = Timeline;

export {
  timeline_default
};
